import { node } from "~/util/dom";
import { _ } from "~/i18n";
import { IMapState } from "~/state/map/interfaces";
import { store } from "~/state/store";
import { watch, watchMapPosition, watchOphotoDate } from "~/state/util";
import { isPointInStatePolygon } from "~/util/state-polygon";
import { CONFIG } from "~/config";

export default class Copyright {
	#container: HTMLDivElement;

	constructor() {
		this.#container = node("div", { className: "ui-map-copyright print" });
		// nastavime uvodni data
		this.#setState(store.getState().map);

		// zmeny souradnic
		const wtMapPosition = watch(store.getState, "map", watchMapPosition);
		// zmeny data foceni
		const wtOphotoDate = watch(store.getState, "map", watchOphotoDate);

		store.subscribe(wtMapPosition((state: IMapState) => {
			this.#setState(state);
		}));
		store.subscribe(wtOphotoDate((state: IMapState) => {
			this.#setState(state);
		}));
	}

	get container() {
		return this.#container;
	}

	async #setState(state: IMapState) {
		const { ophotoDate, longitude, latitude } = state;
		const isCzech = await isPointInStatePolygon(longitude, latitude, {
			cs: true,
		});
		const parts = [
			`&copy; <a href="https://o-seznam.cz/" target="_blank" rel="noopener">Seznam.cz, a.s.</a>, ${new Date().getFullYear()}`,
			...isCzech
				? []
				: [", ", _("copyright.openstreetmap", {
					linkStart: `<a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">`,
					linkEnd: "</a>",
				})],
			" ",
			_("copyright.others", {
				linkStart: `<a href="https://licence.mapy.cz/?doc=mapy_attr${CONFIG.defaultLang === "cs" ? "" : `&lang=${CONFIG.defaultLang}`}" target="_blank" rel="noopener">`,
				linkEnd: "</a>",
			}),
			...ophotoDate ? [" | ", ophotoDate] : [],
			...CONFIG.inFrame ? [" | ", _("copyright.licence")] : [],
		];

		this.#container.innerHTML = parts.join("");
	}
}
